module.exports = function isDefined(obj){return !(obj===null || typeof obj === 'undefined');};


/*****************
 ** WEBPACK FOOTER
 ** ./lib/isDefined.js
 ** module id = 31
 ** module chunks = 0
 **/